import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../utils/analytics";

const PageTracker = () => {
  const location = useLocation(); // ルートの変更を検知

  useEffect(() => {
    trackPageView(location.pathname); // ルートが変わるたびにGA4に送信
  }, [location]);

  return null; // UIを持たないコンポーネント
};

export default PageTracker;